if (!customElements.get('pakiet-life-popup')) {
  customElements.define(
    'pakiet-life-popup',
    class PakietLifePopup extends DrawerComponent {
      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        try {
          this.bundleItems = JSON.parse(this.dataset.items || '[]');
        } catch (e) {
          this.bundleItems = [];
        }
        this.bundleVariantId = Number(this.dataset.bundleVariantId) || null;
        this.threshold = Number(this.dataset.threshold) || 3;
        this.dismissKey = this.dataset.dismissKey || 'pakietLifePopupDismissed';

        if (!this.bundleItems.length || !this.bundleVariantId) return;

        this.ctaBtn = this.querySelector('[data-pakiet-life-cta]');
        this.dismissBtn = this.querySelector('[data-pakiet-life-dismiss]');
        this.itemEls = this.querySelectorAll('.pakiet-life-popup__item');

        this.ctaBtn.addEventListener('click', this.swapToBundle.bind(this));
        if (this.dismissBtn) {
          this.dismissBtn.addEventListener('click', () => {
            this.setDismissed();
            this.hide();
          });
        }

        if (Shopify.designMode) return;

        this._checkListener = () => this.fetchCartAndCheck();
        document.addEventListener('cart:updated', this._checkListener);
        window.FoxTheme.DOMready(this._checkListener);
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        if (this._checkListener) {
          document.removeEventListener('cart:updated', this._checkListener);
        }
      }

      isDismissed() {
        try { return sessionStorage.getItem(this.dismissKey) === '1'; } catch (e) { return false; }
      }
      setDismissed() {
        try { sessionStorage.setItem(this.dismissKey, '1'); } catch (e) {}
      }

      findInCart(cart, variantId) {
        return cart.items.find((it) => it.variant_id === variantId || it.id === variantId);
      }

      fetchCartAndCheck() {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => this.checkCart(cart))
          .catch(() => {});
      }

      checkCart(cart) {
        if (Shopify.designMode || !cart || !cart.items || this.isDismissed()) return;

        const present = this.bundleItems.filter((bi) => !!this.findInCart(cart, bi.variantId));

        this.itemEls.forEach((li) => {
          const vid = Number(li.dataset.variantId);
          const inCart = present.some((bi) => bi.variantId === vid);
          li.classList.toggle('is-in-cart', inCart);
        });

        if (present.length >= this.threshold) {
          this.show();
        } else {
          this.hide();
        }
      }

      swapToBundle() {
        if (Shopify.designMode) return;
        this.ctaBtn.disabled = true;

        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            const updates = {};
            this.bundleItems.forEach((bi) => {
              const item = this.findInCart(cart, bi.variantId);
              if (item) updates[item.key] = 0;
            });
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates }),
            });
          })
          .then(() =>
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: this.bundleVariantId, quantity: 1 }),
            })
          )
          .then(() => {
            this.setDismissed();
            this.hide();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          })
          .catch((err) => console.error('Pakiet LIFE swap error:', err))
          .finally(() => {
            this.ctaBtn.disabled = false;
          });
      }
    }
  );
}